import { useEffect } from 'react'
import Image from 'next/image'
import { datadogLogs } from '@datadog/browser-logs'
import { useAreAllowedGamesFetched, useGetCurrentGame, useGetGameConfig } from 'src/store/game'
import { transformPresets, useViewportScale } from 'src/hooks/useViewportScale'
import { isMarbleGame } from 'src/types/domain/Game'
import { useGames } from 'src/hooks/useGames'
import { useUIActions } from 'src/store/ui'
import { useGetCurrentPlayerId } from 'src/store/player'
import { ShowGamesContainer } from '../ShowGames/ShowGamesContainer'
import { TracksPanelButtons } from './components/TracksPanelButtons'

type Props = Readonly<{
  isScheduledRace: boolean
}>

export function GameTracksPanel({ isScheduledRace }: Props) {
  const currentGame = useGetCurrentGame()
  const { tracksPanelOpened } = useUIActions()
  const currentPlayerId = useGetCurrentPlayerId()
  const { fetchPlayableGames } = useGames()
  const areAllowedGamesFetched = useAreAllowedGamesFetched()
  const { lobbyDisabled } = useGetGameConfig()

  const scaleStyle = useViewportScale({
    transform: transformPresets.basic,
    disableOnTablet: true,
  })

  useEffect(() => {
    void fetchPlayableGames()
  }, [areAllowedGamesFetched, fetchPlayableGames])

  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (isScheduledRace) return

    const target = e.target as HTMLElement
    const isTrackCard = target.closest('.game-lobby-races_entry')
    const isButton = target.closest('button')

    if (!isTrackCard && !isButton) {
      tracksPanelOpened(false)

      datadogLogs.logger.info('tracks_panel', {
        user_action: {
          type: 'close_background',
          currentGame: isMarbleGame(currentGame) ? currentGame.id : null,
          playerId: currentPlayerId
        }
      })
    }
  }

  return (
    <div className="game-tracks-panel" onClick={handleBackgroundClick}>
      {(isScheduledRace && lobbyDisabled && isMarbleGame(currentGame)) ? (
        <div className="scheduled-background-container">
          <div className="scheduled-background-image">
            <Image
              alt={currentGame.track.name}
              className="object-cover"
              fill
              priority={false}
              sizes="100vw"
              src={currentGame.track.background}
            />
          </div>
        </div>
      ) : null}

      <div className={`game-tracks-panel__inner ${isScheduledRace ? 'scheduled-race' : ''} ${!lobbyDisabled ? 'show-tracks' : ''}`}>
        <div className="game-tracks-panel__inner-container" style={scaleStyle}>
          <TracksPanelButtons
            gameId={isMarbleGame(currentGame) ? currentGame.id : null}
            isScheduled={isScheduledRace}
          />
          <div className="game-tracks-panel__tracks">
            <ShowGamesContainer />
          </div>
        </div>
      </div>
    </div>
  )
}
